module.exports = __webpack_public_path__ + "static/media/toggle_btn.4c744ff1.svg";